export default __webpack_public_path__ + "media/images/zinc-educational-services-horizontal-3d5756bf.png";